<script>

import Layout from "../../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Swal from "sweetalert2";

import { ref } from "vue";

import { useCurrencyStore } from '@/store/currencyStore'


/**
 * Dashboard Component
 */
export default {
  setup() {
    const doesAddOpen = ref(false);
    const doesEditOpen = ref(false);
    const doesDeleteOpen = ref(false);
    const doesLoadingOpen = ref(false);
    const currencyStore = useCurrencyStore();

    return {
      doesAddOpen,
      doesEditOpen,
      doesDeleteOpen,
      doesLoadingOpen,
       currencyStore,
    };
  },
  page: {
    title: "currencies",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "currencies",
      items: [
        {
          text: "Définition",
        },
        {
          text: "Currencies",
          active: true,
        },
      ],
      errors: [],
      currency: {},
      currencies: [],
      isoCode: "",
      symbol: "",
      name_en: "",
      name_fr: "",
      name_ru: "",
      name_pt: "",
      min: 0,
      max: 0,
      loading: false,
      statusHttp: 201,
    };
  },

  methods: { 

  async loadFromStore() {

      if (!this.currencyStore.list) {
       await  this.currencyStore.loadFromApi(true).then(data => {
        this.currencies = data
        this.currency_search = data
    })
      } else {
        this.currencies = this.currencyStore.list
        this.currency_search = this.currencies
      }

  },

  addItem() {
      this.errors = [];
      let body = {
        isoCode: this.isoCode,
        symbol: this.symbol,
        name_en: this.name_en,
        name_fr: this.name_fr,
        name_ru: this.name_ru,
        name_pt: this.name_pt,
        min: this.min,
        max: this.max,
      };
      this.currencyStore.createItem(body);
      this.currencies = this.currencyStore.list
      this.currency_search = this.currencies

    },

    compileToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.onmouseenter = Swal?.stopTimer;
            toast.onmouseleave = Swal?.resumeTimer;
          },
        });
        Toast.fire({
          icon: "success",
          title: "Le texte a été copié dans le presse-papier.",
        });
      });
    },

  editItem() {
    this.errors = [];
       let body = {
        isoCode: this.isoCode,
        symbol: this.symbol,
        name_en: this.name_en,
        name_fr: this.name_fr,
        name_ru: this.name_ru,
        name_pt: this.name_pt,
        min: this.min,
        max: this.max,
      };

      this.currencyStore.editItem(this.currency.id, body);
      this.currencies = this.currencyStore.list
      this.currency_search = this.currencies

     
  },

  deleteIt() {
      this.currencyStore.deleteItem(this.currency.id);
      this.currencies = this.currencyStore.list
      this.currency_search = this.currencies
  },











    initItem(currency, action = "edit") {
      this.currency = currency;
      this.initData(currency);
      if (action == "delete") {
        this.doesDeleteOpen = true;
      } else {
        this.doesEditOpen = true;
      }
    },

    initData(item = null) {
      this.isoCode = item != null ? item.isoCode : "";
      this.symbol = item != null ? item.symbol : "";
      this.name_en = item != null ? item.name_en : "";
      this.name_fr = item != null ? item.name_fr : "";
      this.name_ru = item != null ? item.name_ru : "";
      this.name_pt = item != null ? item.name_pt : "";
      this.min = item != null ? item.min : 0;
      this.max = item != null ? item.max : 0;
    },
  },
  mounted() {
    this.loadFromStore();
    this.doesLoadingOpen = false;
  },
  watch: {
    doesAddOpen: function () {
      this.errors = [];
      if (!this.doesAddOpen) {
        this.initData(null);
      }
    },
    doesEditOpen: function () {
      this.errors = [];
      if (!this.doesEditOpen) {
        this.initData(null);
        this.currency = null;
      }
    },
    doesDeleteOpen: function () {
      if (!this.doesDeleteOpen) {
        this.initData(null);
        this.currency = null;
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="hstack mb-3" v-show="status != 403">
      <b-button variant="primary" @click="doesAddOpen = true" class="ms-auto">
        <i class="bx bx-plus font-size-16 align-middle me-2"></i>
        Ajouter un nouveau
      </b-button>
    </div>

    <div class="row" v-show="status != 403">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Listes des currencies</h4>
            <p class="card-title-desc">
              Le tableau ci-dessous présente la listes des <code>currencies</code>.
            </p>

            <div class="table-responsive">
              <table class="table align-middle mb-0">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>currency</th>
                    <th>Isocode</th>
                    <th>Symbole</th>
                    <th>Interval</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(currency, i) in currencies" :key="currency.id">
                    <th scope="row"  v-on:click="compileToClipboard(currency.id)"
                      style="cursor: pointer">{{ i + 1 }}</th>
                    <td>{{ currency.name_fr }}</td>
                    <td>{{ currency.isoCode }}</td>
                    <td>{{ currency.symbol }}</td>
                    <td>{{ Number(currency.min | Number(0.00, )) }} - {{ Number(currency.max) }}</td>
                    <td class="hstack">
                      <b-button
                        class="btn-sm ms-2"
                        @click="initItem(currency, 'edit')"
                        variant="success"
                      >
                        <i class="bx bx-edit font-size-16 align-middle mx-1"></i>
                      </b-button>
                      <b-button
                        variant="danger"
                        @click="initItem(currency, 'delete')"
                        class="ms-2 btn-sm"
                      >
                        <i class="bx bx-trash font-size-16 align-middle mx-1"></i>
                      </b-button>
                      <router-link :to="'/currencies/' + currency.id">
                        <b-button class="btn-sm ms-2 rounded-pill px-2" variant="primary">
                          Details
                        </b-button>
                      </router-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-show="status === 403">
      <h3 class="text-danger text-center my-5">Réserver à l'administrateur principal</h3>
    </div>

    <!-- LOADING MODAL -->
    <b-modal
      v-model="doesLoadingOpen"
      id="modal-center"
      centered
      size="md"
      title="Chargement..."
      title-class="font-18"
      hide-footer
    >
      <div class="text-center">
        <div class="spinner-border text-primary-" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </b-modal>

    <!-- ADD MODAL -->
    <b-modal
      v-model="doesAddOpen"
      id="modal-center"
      centered
      size="lg"
      title="Ajouter un currency"
      title-class="font-18"
      hide-footer
    >
      <form @submit.prevent="addItem()">
        <div class="row">
          <div class="col-md-6 mb-3">
            <label for="">Iso Code</label>
            <input type="text" required v-model="isoCode" class="form-control" />
            <span class="text-danger mt-2" v-if="errors.isoCode">{{
              errors.isoCode
            }}</span>
          </div>
          <div class="col-md-6 mb-3">
            <label for="">Symbole</label>
            <input type="text" required v-model="symbol" class="form-control" />
            <span class="text-danger mt-2" v-if="errors.symbol">{{ errors.symbol }}</span>
          </div>
          <div class="col-md-6 mb-3">
            <label for="">Min</label>
            <input type="number" required v-model="min" class="form-control" />
            <span class="text-danger mt-2" v-if="errors.min">{{ errors.min }}</span>
          </div>
          <div class="col-md-6 mb-3">
            <label for="">Max</label>
            <input type="number" required v-model="max" class="form-control" />
            <span class="text-danger mt-2" v-if="errors.max">{{ errors.max }}</span>
          </div>
          <div class="col-md-6 mb-3">
            <label for="">Name EN</label>
            <input type="text" required v-model="name_en" class="form-control" />
            <span class="text-danger mt-2" v-if="errors.name_en">{{
              errors.name_en
            }}</span>
          </div>
          <div class="col-md-6 mb-3">
            <label for="">Name FR</label>
            <input type="text" required v-model="name_fr" class="form-control" />
            <span class="text-danger mt-2" v-if="errors.name_fr">{{
              errors.name_fr
            }}</span>
          </div>
          <div class="col-md-6 mb-3">
            <label for="">Name RU</label>
            <input type="text" required v-model="name_ru" class="form-control" />
            <span class="text-danger mt-2" v-if="errors.name_ru">{{
              errors.name_ru
            }}</span>
          </div>
          <div class="col-md-6 mb-3">
            <label for="">Name PT</label>
            <input type="text" required v-model="name_pt" class="form-control" />
            <span class="text-danger mt-2" v-if="errors.name_pt">{{
              errors.name_pt
            }}</span>
          </div>
        </div>
        <div class="mt-3" v-if="!loading">
          <input type="submit" value="Enregistrer" class="btn btn-primary" />
        </div>
        <div class="mt-3 text-center" v-else>
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </form>
    </b-modal>

    <!-- EDIT MODAL -->
    <b-modal
      v-model="doesEditOpen"
      id="modal-center"
      centered
      size="lg"
      title="Modifier un currency"
      title-class="font-18"
      hide-footer
    >
      <form @submit.prevent="editItem()">
        <div class="row">
          <div class="col-md-6 mb-3">
            <label for="">Iso Code</label>
            <input type="text" required v-model="isoCode" class="form-control" />
            <span class="text-danger mt-2" v-if="errors.isoCode">{{
              errors.isoCode
            }}</span>
          </div>
          <div class="col-md-6 mb-3">
            <label for="">Symbole</label>
            <input type="text" required v-model="symbol" class="form-control" />
            <span class="text-danger mt-2" v-if="errors.symbol">{{ errors.symbol }}</span>
          </div>
          <div class="col-md-6 mb-3">
            <label for="">Min</label>
            <input type="number" required v-model="min" class="form-control" />
            <span class="text-danger mt-2" v-if="errors.min">{{ errors.min }}</span>
          </div>
          <div class="col-md-6 mb-3">
            <label for="">Max</label>
            <input type="number" required v-model="max" class="form-control" />
            <span class="text-danger mt-2" v-if="errors.max">{{ errors.max }}</span>
          </div>
          <div class="col-md-6 mb-3">
            <label for="">Name EN</label>
            <input type="text" required v-model="name_en" class="form-control" />
            <span class="text-danger mt-2" v-if="errors.name_en">{{
              errors.name_en
            }}</span>
          </div>
          <div class="col-md-6 mb-3">
            <label for="">Name FR</label>
            <input type="text" required v-model="name_fr" class="form-control" />
            <span class="text-danger mt-2" v-if="errors.name_fr">{{
              errors.name_fr
            }}</span>
          </div>
          <div class="col-md-6 mb-3">
            <label for="">Name RU</label>
            <input type="text" required v-model="name_ru" class="form-control" />
            <span class="text-danger mt-2" v-if="errors.name_ru">{{
              errors.name_ru
            }}</span>
          </div>
          <div class="col-md-6 mb-3">
            <label for="">Name PT</label>
            <input type="text" required v-model="name_pt" class="form-control" />
            <span class="text-danger mt-2" v-if="errors.name_pt">{{
              errors.name_pt
            }}</span>
          </div>
        </div>
        <div class="mt-3" v-if="!loading">
          <input type="submit" value="Enregistrer" class="btn btn-primary" />
        </div>
        <div class="mt-3 text-center" v-else>
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </form>
    </b-modal>

    <!-- DELETE MODAL -->
    <b-modal
      v-model="doesDeleteOpen"
      id="modal-center"
      title="Supprimer un currency"
      title-class="font-18"
      hide-footer
    >
      <p class="mb-2">
        Voulez-vous vraiment supprimer le currency <b>{{ currency?.name_fr }}</b> ?
      </p>
      <div class="hstack mt-2" v-if="!loading">
        <button class="btn btn-dark ms-auto" @click="doesDeleteOpen = false">
          Annuler
        </button>
        <button class="ms-3 btn btn-danger" @click="deleteIt()">Supprimer</button>
      </div>
      <div class="text-center" v-else>
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </b-modal>
  </Layout>
</template>
